import { getAppEnv, isNodeProd } from '../base/env'
import Agent, { compareVersion } from '../agent'
import { NATIVE_APP_NAME, APP_NAME } from '../agent/typing'
import { APP_ENV } from '../consts'
import knbUse, { wxReady } from './knb-use'
import { reportError, reportWarn } from '../owl'
import { lxMC, lxMV } from '../lx'
import { T_SHARECONFIG } from './types'

export const appConfigMap: Record<
  NATIVE_APP_NAME,
  {
    id: string
    mpappnm: string
  }
> = {
  [NATIVE_APP_NAME.dianping_nova]: {
    id: 'gh_bc5b635c05c4', // 点评不可分享为民宿小程序(不在一个公众号主体)
    mpappnm: 'dianping_wxapp',
  },
  [NATIVE_APP_NAME.group]: {
    // id: 'gh_870576f3c6f9', // 美团小程序id
    id: 'gh_8c04beb7e27c', // 美团分享为民宿小程序
    mpappnm: 'phoenix_wxapp',
  },
  [NATIVE_APP_NAME.phoenix]: {
    id: 'gh_8c04beb7e27c',
    mpappnm: 'phoenix_wxapp',
  },
  [NATIVE_APP_NAME.phoenix_i]: {
    id: 'gh_8c04beb7e27c',
    mpappnm: 'phoenix_wxapp',
  },
}

// 配置小程序转发
export function configSharePhxWxApp(shareConfig: T_SHARECONFIG) {
  if (!shareConfig.miniProgram) return
  const message = {
    data: {
      action: 'share', // 美团民宿系小程序/点评小程序
      type: 'share', // 美团小程序
      data: {
        title: shareConfig.title,
        path:
          typeof shareConfig.miniProgram.path === 'string'
            ? shareConfig.miniProgram.path
            : (shareConfig.miniProgram.path as Record<APP_NAME, string>)[Agent.appnm],
        imageUrl: shareConfig.miniProgram.image || DEFAULT_IMAGE,
        uri: Agent.dianping_wxapp ? window.location.href : shareConfig.url,
      },
    },
  }
  console.log('[PrePostMessage]', JSON.stringify(message))
  wxReady(() => {
    console.log('[DoPostMessage]')
    window.wx.miniProgram.postMessage(message)
  })
}

const DEFAULT_IMAGE = 'https://p0.meituan.net/scarlett/86f86efe315bc36a8b21309791e361888420.png'
// function hideShare() {
//   const message = {
//     data: {
//       action: 'hide-share',
//     },
//   }
//   wxReady(() => {
//     console.log('[postMessage]', JSON.stringify(message))
//     window.wx.miniProgram.postMessage(message)
//   })
// }

function processMPConfig(_config: T_SHARECONFIG) {
  const { notSupportDpWxApp, ...config } = _config
  const miniProgram = config.miniProgram
  // 需要关注服务号的助力活动由于点评与美团不在一个公众号主体，分享为点评小程序会出错，置为空
  if (miniProgram && !(Agent.dianping && notSupportDpWxApp)) {
    miniProgram.type = getAppEnv() === APP_ENV.production ? 0 : 2 // 分享小程序类型，包含正式版-0、开发版-1、体验版-2，默认正式版,
    let mpConfig: { id: string; mpappnm: string } = appConfigMap[NATIVE_APP_NAME.phoenix]
    const appnm = Agent.appnm as NATIVE_APP_NAME
    if (
      [NATIVE_APP_NAME.dianping_nova, NATIVE_APP_NAME.group, NATIVE_APP_NAME.phoenix].indexOf(appnm) !== -1 &&
      appConfigMap[appnm]
    ) {
      mpConfig = appConfigMap[appnm]
    }
    // 默认分享为美团民宿小程序
    if (!miniProgram.id) {
      miniProgram.id = mpConfig.id
    }
    if (Object.prototype.toString.call(miniProgram.path) === '[object Object]') {
      const paths = miniProgram.path as Record<string, string>
      if (paths[mpConfig.mpappnm]) {
        miniProgram.path = paths[mpConfig.mpappnm] || ''
      } else {
        reportError({
          name: '分享地址错误',
          msg: _config,
          global: true,
        })
      }
    }
  }
  return miniProgram
}

function reportShareError(error: any) {
  if (Agent.native || Agent.weixin) {
    lxMV('b_airbnb_28pnk27w_mv', {
      custom: {
        message: JSON.stringify(error),
      },
    })
    if (Agent.weixin) {
      const errMeg = error && error.errMsg ? error.errMsg : ''
      if (Agent.pcwechat) {
        if (
          [
            'updateTimelineShareData:function not implement',
            'updateAppMessageShareData:function not implement',
          ].indexOf(errMeg) === -1
        ) {
          reportWarn({
            name: '分享配置失败PC' + errMeg,
            msg: error,
            global: true,
          })
        }
      } else {
        // 可能原因：版本过低，wx.config 注册失败
        reportWarn({
          name: (Agent.wxwork ? '分享配置失败企业微信' : '分享配置失败微信') + errMeg,
          msg: error,
        })
      }
    }
  }
}

export function processShareConfig(_config: T_SHARECONFIG): any {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { notSupportDpWxApp, ...config } = _config
  config.miniProgram = processMPConfig(_config)
  if (!config.title) {
    config.title = '美团民宿'
  }
  if (!config.content) {
    config.content = '【' + config.title + '】' + config.desc
  }
  config.panel = _config.panel || {
    // 选填，详情信息参考 https://km.sankuai.com/page/170825132
    cid: window.LX_PAGE_CID,
  }
  config.handle = (evt: any) => {
    if (typeof _config.handle === 'function') {
      _config.handle(evt)
    }
    lxMC('b_1lxohet0')
  }
  // 美团民宿安卓3.10.0以上才有回调
  config.success = (channel: any) => {
    if (typeof _config.success === 'function') {
      _config.success(channel)
    }
    lxMV('b_airbnb_fvu1k6su_mv', {
      custom: {
        message: JSON.stringify(channel),
      },
    })
  }
  config.fail = (error: any) => {
    if (typeof _config.fail === 'function') {
      _config.fail(error)
    }
    reportShareError(error)
  }
  // console.log('[shareConfig]', JSON.stringify(config))
  return config
}

function lowVersionWxConfig(shareConfig: T_SHARECONFIG) {
  ;((shareConfig.channel || ['WECHAT_FRIENDS', 'WECHAT_TIMELINE']) as string[]).forEach((ch) => {
    switch (ch) {
      case 'WECHAT_FRIENDS':
        window.wx.onMenuShareAppMessage({
          title: shareConfig.title, // 分享标题
          desc: shareConfig.desc, // 分享描述
          link: shareConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareConfig.image || DEFAULT_IMAGE, // 分享图标
          success: shareConfig.success,
          fail: shareConfig.fail,
        })
        break
      case 'WECHAT_TIMELINE':
        window.wx.onMenuShareTimeline({
          title: '【' + shareConfig.title + '】' + shareConfig.desc, // 分享标题
          link: shareConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareConfig.image || DEFAULT_IMAGE, // 分享图标
          success: shareConfig.success,
          fail: shareConfig.fail,
        })
        break
    }
  })
}

export function knbConfigShare(_shareConfig: T_SHARECONFIG, notitlebar?: boolean) {
  if (!_shareConfig.image) {
    _shareConfig.image = DEFAULT_IMAGE
  }
  if (Agent.miniprogram) {
    if (_shareConfig.miniProgram) configSharePhxWxApp(_shareConfig)
    return
  }
  if (Agent.weixin) {
    window.$bus.$on('route-change', () => {
      console.log('route-change-config-share', _shareConfig)
      knbConfigShare(_shareConfig)
    })
    const shareConfig = processShareConfig(_shareConfig)
    if (Agent.pcwechat || Agent.wxwork) {
      // pc 不知道暂时没有支持新接口，两种都调一下
      wxReady(() => {
        lowVersionWxConfig(shareConfig)
      })
      wxReady(() => {
        knbUse('configShare', shareConfig)
      })
    } else if (compareVersion(Agent.uaInfo.micromessenger, '6.7.2') < 0) {
      // 手机端低于6.7.2版本没有updateAppMessageShareData
      reportWarn({
        name: '分享微信版本低',
        msg: Agent.uaInfo.micromessenger,
        global: true,
      })
      wxReady(() => {
        lowVersionWxConfig(shareConfig)
      })
    } else {
      wxReady(() => {
        knbUse('configShare', shareConfig)
      })
    }
    return
  }
  const shareConfig = processShareConfig(_shareConfig)
  if (!isNodeProd()) {
    console.info('[shareConfig]', shareConfig)
  }
  // 鸿蒙先屏蔽分享功能
  if (Agent.native && !notitlebar) {
    knbUse('configShare', shareConfig)
  }
}
